export var LOCALE_LOCAL_STORAGE_KEY = 'LOCALE_LOCAL_STORAGE_KEY';
export var ANALYSIS_GUIDE_LOCALE_LOCAL_STORAGE_KEY = 'ANALYSIS_GUIDE_LOCALE_LOCAL_STORAGE_KEY';
export var CLIENT_LIST_SORT_TYPE_STORAGE_KEY = 'ClientListSortType';
export var CLIENT_LIST_SORT_ORDER_TYPE_STORAGE_KEY = 'ClientListSortOrderType';
export var NOTE_EDITOR_PREVIOUS_MODE_LOCAL_STORAGE_KEY = 'NOTE_EDITOR_PREVIOUS_MODE_LOCAL_STORAGE_KEY';
export var NOTES_FILTER_LOCAL_STORAGE_KEY = 'NOTES_FILTER_LOCAL_STORAGE_KEY';
export var BRANCH_LOCAL_STORAGE_KEY = 'BRANCH_LOCAL_STORAGE_KEY';
export var SHOW_SIDE_BAR_LOCAL_STORAGE_KEY = 'SHOW_SIDE_BAR_LOCAL_STORAGE_KEY';
export var DISPLAY_MEASUREMENT_CHARTS_LOCAL_STORAGE_KEY = 'DISPLAY_MEASUREMENT_CHARTS_LOCAL_STORAGE_KEY';